import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export function ChangePasswordGate() {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  if (!user?.must_change_password) return null;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (f.next !== f.confirm) return toast.error("The new passwords don't match");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      setUser(data);
      toast.success("Password saved. Welcome aboard!");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[100] bg-slate-950/70 backdrop-blur-sm grid place-items-center p-4" data-testid="change-password-gate">
      <form onSubmit={submit} className="w-full max-w-md bg-white rounded-3xl p-7 shadow-2xl space-y-3">
        <div className="w-11 h-11 rounded-2xl bg-[#D4A12A]/15 grid place-items-center"><KeyRound className="w-5 h-5 text-[#A87A12]" /></div>
        <h2 className="font-serif text-2xl font-semibold">Choose your own password</h2>
        <p className="text-sm text-slate-500">You signed in with the temporary password from your welcome email. Set a new one to continue.</p>
        <Input type="password" required placeholder="Temporary password" value={f.current} onChange={set("current")} className="h-11" data-testid="cp-current" />
        <Input type="password" required minLength={8} placeholder="New password (at least 8 characters)" value={f.next} onChange={set("next")} className="h-11" data-testid="cp-new" />
        <Input type="password" required minLength={8} placeholder="Repeat new password" value={f.confirm} onChange={set("confirm")} className="h-11" data-testid="cp-confirm" />
        <button disabled={busy} className="w-full h-11 rounded-full bg-[#0F2A47] text-white font-semibold disabled:opacity-60" data-testid="cp-submit">{busy ? "Saving…" : "Save password"}</button>
      </form>
    </div>
  );
}
